var $ad2bcec7a0192558$exports = {};
function $ad2bcec7a0192558$var$main() {
    window.addEventListener('hashchange', (event)=>{
        const id = window.location.hash.slice(1);
        const prev = event.oldURL.includes('#') ? event.oldURL.split('#')[1] : '';
        if (prev == '' && id.length) console.log(`hope you enjoy your first article of the visit, "${$ad2bcec7a0192558$var$titleFromSlug(id)} :)"`);
        $ad2bcec7a0192558$var$expandArticle(id);
    });
    if (window.location.hash) {
        const id = window.location.hash.slice(1);
        $ad2bcec7a0192558$var$expandArticle(id);
    }
}
function $ad2bcec7a0192558$var$titleFromSlug(slug) {
    const elems = Array.from(document.querySelectorAll('article > h2')).filter((n)=>n.id.toLowerCase() === slug.toLowerCase());
    if (elems.length == 0) return '';
    if (elems.length > 1) console.log(`i have two articles with the same slug! i better fix that...`);
    if (elems[0].textContent == null) return '';
    return elems[0].textContent;
}
function $ad2bcec7a0192558$var$expandArticle(slug) {
    if (slug == '') return;
    const article = document.querySelector(`#${slug}`)?.parentElement?.parentElement;
    if (!article) return;
    article.classList.replace('collapsed', 'expanded');
    const a = article?.querySelector(`a.article-expander`);
    if (a) {
        a.text = '...enough';
        a.addEventListener('click', ()=>{
            $ad2bcec7a0192558$var$collapseArticle(article);
            a.addEventListener('click', ()=>{
                $ad2bcec7a0192558$var$expandArticle(slug);
            }, {
                once: true
            });
            return true;
        }, {
            once: true
        });
    }
}
function $ad2bcec7a0192558$var$collapseArticle(article) {
    article.classList.replace('expanded', 'collapsed');
    const a = article.querySelector(`a.article-expander`);
    if (a) a.text = 'more...';
}
(async ()=>{
    $ad2bcec7a0192558$var$main();
})();


//# sourceMappingURL=justintout.com.640c1821.js.map
